import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// Components
import Form from "~/common/components/Form";
import Input from "~/common/components/Input";
import Select from "~/common/components/Select";
import Textarea from "~/common/components/textarea";

// Assets
import "~/assets/sass/pages/invest/evaluteDetail.scss";
import { WarningIcon } from "~/assets/svg/AlertIcon";


//
import Processing from "~/pages/investment/InvestSettingPage/processingModal/Processing";
import ProcessAlerts from "~/pages/investment/InvestSettingPage/processingModal/ProcessAlerts";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";

const RequestForm = ({
	setCardStep,
	evaluateRequestForm,
	setRequestAlert,
	setEvaluateTemplateAlert,
	settingList,
	setDataFromReqForm,
	setTitleContentCheck,
	setSettingItemCheck,
	settingListRequest
}) => {
	const { t } = useTranslation();
	const requestTitle = evaluateRequestForm.watch("evaluateTitle");
	const requestEvalItem = evaluateRequestForm.watch("evaluateTemplate");
	const requestContent = evaluateRequestForm.watch("evaluateMessage");

	// invest modal
	const [deleteAlertModal, setDeleteAlertModal] = useState(false);
	const [noCategoryAlert, setNoCategoryAlert] = useState(false);
	const [weightingAlert, setWeightingAlert] = useState(false);
	const [noEvaluationAlert, setNoEvaluationAlert] = useState(false);
	const [noTitleAlert, setNoTitleAlert] = useState(false);
	const [noCategoryName, setNoCategoryName] = useState(false);
	const [noItemName, setNoItemName] = useState(false);
	const [settingDetail, setSettingDetail] = useState({});
	const [resetItemData, setResetData] = useState("");
	const [targetIdx, setTargetIdx] = useState("");
	const [createNew, setCreateNew] = useState("notCreate");
	const [roundItemModal, setRoundItemModal] = useState(false);
	const [isSelect, setIsSelect] = useState(false)

	// API

	const settingCreateRequest = useRequest("post", "/vc/invest/setting/add");
	const settingModifyRequest = useRequest("post", "/vc/invest/setting/edit");
	const settingDeleteRequest = useRequest("delete", "/vc/invest/setting/delete");

	// Invest modal
	const doDelete = (idx) => {
		settingDeleteRequest.call(idx, "path");
	};
	const handleCreate = () => {
		setCreateNew("create");
		setRoundItemModal(true);
	};
	const handleModify = (modiFormData) => {
		settingModifyRequest.call(modiFormData);
	};
	const handleNewCreation = (createFormData) => {
		settingCreateRequest.call(createFormData);
	};


	useEffect(() => {
		if (
			requestTitle === undefined ||
			requestContent === undefined ||
			requestTitle.replace(/\s| /gi, "") === "" ||
			requestContent.replace(/\s| /gi, "") === ""
		) {
			setTitleContentCheck(false);
		} else {
			setTitleContentCheck(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [requestTitle, requestContent]);

	useEffect(() => {
		if (requestEvalItem === undefined) {
			setSettingItemCheck(false);
		} else {
			setSettingItemCheck(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [requestEvalItem]);

	const handleNextStep = () => {
		if (
			requestTitle === undefined ||
			requestContent === undefined ||
			requestTitle.replace(/\s| /gi, "") === "" ||
			requestContent.replace(/\s| /gi, "") === ""
		) {
			setRequestAlert(true);
		} else if (requestEvalItem === undefined) {
			setEvaluateTemplateAlert(true);
		} else {
			setDataFromReqForm({
				title: requestTitle,
				content: requestContent,
				settingIdx: requestEvalItem,
			});
			setCardStep(2);
		}
	};


	useEffect(() => {
		switch (settingModifyRequest.state) {
			case API_STATE.done:
				setRoundItemModal(false);
				settingListRequest.call();
				break;
			case API_STATE.error:
				console.log(
					`${t("common.commonWord.button.modify")} error !!! >>`,
					settingModifyRequest.error
				);
				break;
			default:
				break;
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [settingModifyRequest.state, settingModifyRequest.response, settingModifyRequest.error]);

	useEffect(() => {
		switch (settingDeleteRequest.state) {
			case API_STATE.done:
				setDeleteAlertModal(false);
				settingListRequest.call()
				break;
			case API_STATE.error:
				switch (settingDeleteRequest.error.statusCode) {
					case 404:
						alert(t("pages.investment.InvestSettingPage.index.alert01"));
						setDeleteAlertModal(false);
						break;
					case 500:
						alert(t("pages.investment.InvestSettingPage.index.alert02"));
						setDeleteAlertModal(false);
						break;
					default:
						break;
				}
				break;
			default:
				break;
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [settingDeleteRequest.state, settingDeleteRequest.response, settingDeleteRequest.error]);

	useEffect(() => {
		switch (settingCreateRequest.state) {
			case API_STATE.done:
				// let res = settingCreateRequest.response;
				// setSelectValue({
				// 	label: res.title, value: res.idx
				// })
				setRoundItemModal(false);
				settingListRequest.call();
				setIsSelect(true)
				break;
			case API_STATE.error:
				console.log("settingCreateRequest error !!! >> ", settingCreateRequest.error);
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [settingCreateRequest.state, settingCreateRequest.response, settingCreateRequest.error]);


	return (
		<>
			<section className="c__card evaluate-card request">
				<Form useForm={evaluateRequestForm}>
					<Input
						label={t(
							"pages.investment.InvestEvalPage.evalRequest.contents.RequestForm.label01"
						)}
						placeholder={t(
							"pages.investment.InvestEvalPage.evalRequest.contents.RequestForm.placeholder01"
						)}
						name="evaluateTitle"
					/>


					{settingList.length === 0 ? (
						<div className="f__group no-evaluate-template">
							<div className="f__label">
								{t(
									"pages.investment.InvestEvalPage.evalRequest.contents.RequestForm.label02"
								)}
							</div>
							<div className="f__control">
								<WarningIcon />
								{t(
									"pages.investment.InvestEvalPage.evalRequest.contents.RequestForm.waiting"
								)}
								{/*<a href="/invest/setting">*/}
								{/*	{t(*/}
								{/*		"pages.investment.InvestEvalPage.evalRequest.contents.RequestForm.link"*/}
								{/*	)}*/}
								{/*</a>*/}
								<button
									className={"highlight"}
									onClick={() => {
										// if (currentPath.auth !== "edit") {
										// 	showAuthAlert();
										// 	return;
										// }
										handleCreate();
									}}
								>
									{t(
										"pages.investment.InvestEvalPage.evalRequest.contents.RequestForm.link"
									)}
								</button>
								{t(
									"pages.investment.InvestEvalPage.evalRequest.contents.RequestForm.linkText"
								)}
							</div>
						</div>
					) : (
						<>
							<Select
								label={t(
									"pages.investment.InvestEvalPage.evalRequest.contents.RequestForm.label02"
								)}
								name="evaluateTemplate"
								options={settingList}
								customStyle={{ width: 'calc(100% - 130px)' }}
								autoSelectNewOption={isSelect}
							/>
							<div className="">
								<button type="button" className="btn__outline angled btn-position"
									color="primary"
									onClick={() => {
										// if (currentPath.auth !== "edit") {
										// 	showAuthAlert();
										// 	return;
										// }
										handleCreate();
									}}
								> 심사항목 신규 등록
								</button>

							</div>
						</>
					)}
					<Textarea
						label={t(
							"pages.investment.InvestEvalPage.evalRequest.contents.RequestForm.label03"
						)}
						name="evaluateMessage"
						placeholder={t(
							"pages.investment.InvestEvalPage.evalRequest.contents.RequestForm.placeholder02"
						)}
						onChange={100}
					/>
				</Form>
				<div className="btn-wrap">
					<button
						type="button"
						className="btn__solid"
						color="primary"
						onClick={handleNextStep}
					>
						{t("pages.investment.InvestEvalPage.evalRequest.contents.RequestForm.button")}
					</button>
				</div>
			</section >

			<Processing
				{...{
					settingDetail,
					setSettingDetail,
					createNew,
					roundItemModal,
					setRoundItemModal,
					setNoCategoryAlert,
					setWeightingAlert,
					setNoEvaluationAlert,
					setNoTitleAlert,
					resetItemData,
					setResetData,
					setNoCategoryName,
					setNoItemName,
					handleModify,
					handleNewCreation,
					targetIdx,
				}}
			/>

			<ProcessAlerts
				{...{
					noCategoryAlert,
					setNoCategoryAlert,
					weightingAlert,
					setWeightingAlert,
					deleteAlertModal,
					setDeleteAlertModal,
					noEvaluationAlert,
					setNoEvaluationAlert,
					noTitleAlert,
					setNoTitleAlert,
					noCategoryName,
					setNoCategoryName,
					noItemName,
					setNoItemName,
					doDelete,
					targetIdx,
				}}
			/>

		</>
	);
};

export default RequestForm;
